module.exports = __webpack_public_path__ + "img/cad.982d3b6d.png";